<template>
    <div>
        <div class="flex alc">
            <el-select class="marr4" filterable size="mini" v-model="i_state">
                <el-option v-for="item in stateList" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
            </el-select>
            <el-select class="marr4" filterable clearable size="mini" v-model="vc_lang_search">
                <el-option v-for="item in language" :key="item.i_id" :label="item.vc_name" :value="item.i_id"></el-option>
            </el-select>
            <el-select class="marr4" filterable clearable size="mini" v-model="vc_module">
                <el-option v-for="item in moduleList" :key="item.vc_module_key" :label="item.vc_module_value" :value="item.vc_module_key"></el-option>
            </el-select>
            <el-input  class="marr4" style="width: 200px"  v-model="vc_search" placeholder="请输入标签名、标签说明信息" clearable size="mini"></el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="searchFun" size="mini"></el-button>
            <el-button class="marB10"   @click="addFun(null,'add')" :class="baseerp+'btn'" size="mini">{{$t('button_newly_added')}}</el-button>
        </div>
        <el-table class="mrt10" ref="table"  size="mini" :height="tableHeight" border :data="tableData" :header-cell-style="{background:'#eef1f6',color:'#000'}" :highlight-current-row="true" style="width: 100%">
            <template slot="empty">
                <p>{{dataText}}</p>
            </template>
            <el-table-column   type="index" label="序号"></el-table-column>
            <el-table-column   prop="vc_lang" label="语言" width="95" />
            <el-table-column   prop="vc_label_key" label="标签名" min-width="200" />
            <el-table-column   prop="vc_text" label="内容" min-width="200" />
            <el-table-column   prop="vc_module" label="模块" width="180" />
            <el-table-column   prop="vc_description" label="说明" min-width="200"/>
            <el-table-column   prop="dt_createtime" label="录入时间" width="170"/>
            <el-table-column   prop="vc_lruname" label="录入人" width="85" />
            <el-table-column label="操作" width="60" align="center">
                <template slot-scope="scope">
                    <el-button  size="mini" type="text" @click="addFun(scope.row,'edit')" >{{$t('button_edit')}}</el-button>
                </template>
            </el-table-column>

        </el-table>
        <el-pagination style="margin-top: 10px;text-align: right" background @current-change="pageCurrentChange" layout="total,prev, pager, next"
                        :current-page.sync="currentPage" :total="total" :page-size="pageSize">
        </el-pagination>
        <el-dialog
                :style="{ maxHeight: maxDialogHeight + 'px', overflowY: 'auto' }"
                :class="baseerp+'div'"
                top="15vh"
                width="90%"
                :title="addTitle"
                :visible.sync="addVisible"
                :close-on-click-modal="false"
                @close="closeAddFun"
                v-if="addVisible"
                :append-to-body="true">
            <add-page :data="addProp" v-if="addVisible" @success="handleSubSuccess" @close="closeAddFun"></add-page>
        </el-dialog>
    </div>
</template>

<script>
    import * as API from "./api"
    import {baseerp, baseApp, file_url, baseVersion} from "@/utils/baseUrl";
    import {language} from '@/locales/selection'
    import AddPage from "./AddPage";
    //import AddType from "./AddType";

    export default {
        name: "index",
        components: {AddPage},
        props: {
            maxH: {
                type: Number,
                default: 0
            }
        },
        data() {
            return {
                tableHeight: 0,
                baseerp: '',
                canEdit:false,
                tableData:[],
                dataText:this.$t('tips_no_data_available_at_the_moment'),
                addProp:{},
                addTitle:'',
                addVisible:false,
                addMenu:'',
                editMenu:'',
                currentPage:1,
                pageSize:20,
                total:0,
                vc_search:'',
                i_state:0,
                stateList:[{i_id:0,vc_name:this.$t('state_all')},{i_id:1,vc_name:'有效'},{i_id:-1,vc_name:'无效'}],
                vc_lang_search:'',
                language:[],
                vc_module:'',
                moduleList:[],
                isNeedRefresh: false,
            }
        },
        computed: {
        },
        watch: {
            '$root.workSize': {
                handler(n, o) {
                    this.onResize(n);
                },
                deep: true,
            },
        },
        activated() {
            this.onResize();
        },
        mounted() {
            this.baseerp = baseerp;
            this.language = language;
            console.log('this.language',this.language)
            this.$nextTick(() => {
                //this.onResize();
            });
            this.getmodulelist()
            this.getItemList()
        },
        methods: {
            onResize(n) {
                if (n == undefined) n = this.$root.workSize;
                $("#homeBox").height(n.h);
                $("#homeBox").width(n.w);
                this.tableHeight = n.h - (n.h) * 0.3+100;
                if (this.tableHeight < 60) this.tableHeight = 60;
            },
            setDialogHeight() {
                //console.log(window.innerHeight,'window.innerHeight')
                this.maxDialogHeight = window.innerHeight-100;
                const otherHeight =290;
                this.tableHeight = window.innerHeight - otherHeight;
                console.log( this.tableHeight,' this.tableHeight')
            },

            addFun(val,type){
                this.addVisible=true;
                if(type=='add'){
                    this.addTitle='新增标签';
                    this.addProp={
                        //dynamicColumn:this.allColumns,
                        type:type,
                        //maxDialogHeight:this.maxDialogHeight,
                        //data:this.chooseNode
                    };
                }else if(type=='edit'){
                    this.addTitle=this.$t('button_edit')+val.vc_label_key;
                    this.addProp={
                        //dynamicColumn:this.allColumns,
                        type:type,
                        //maxDialogHeight:this.maxDialogHeight,
                        //data:{vc_type:this.chooseNode.vc_name,...val}
                        data:{...val}
                    };
                }

            },
            handleSubSuccess() {
                this.isNeedRefresh = true;
            },
            closeAddFun(){
                this.addVisible=false
                if (this.isNeedRefresh) {
                    this.currentPage=1
                    this.getItemList()
                    this.isNeedRefresh = false;
                }
            },

            searchFun(){
                this.currentPage=1
                this.getItemList()
            },
            pageCurrentChange(val){
                this.currentPage=val;
                this.getItemList()
            },
            async getItemList(){
                let param = {
                    "vc_module":this.vc_module,//搜索模块
                    "vc_lang_search":this.vc_lang_search,//搜索语言
                    "vc_search":this.vc_search,//搜索关键字
                    "i_state":this.i_state,//搜索状态 0：全部，1：有效，-1：无效
                };
                let res = await API.list(param);
                if (res.code == 1) {
                    this.tableData=res.data;
                    this.total=res.data.length;
                    this.setDialogHeight();
                    window.addEventListener('resize', this.setDialogHeight);
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else {
                    this.$message.error(res.message);
                }
            },
            async getmodulelist(){
                let param={};
                let res=await API.modulelist(param);
                if ( res.code == 1 ){
                    this.moduleList=res.data;
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
        },
    }
</script>

<style lang="scss" scoped>
    .mrt10{
        margin-top: 10px;
    }
    .marr4{
        margin-right: 4px;
    }
    .alc{
        align-items: center;
    }
    .flex{
        display: flex;
    }
    .jcbc{
        justify-content: space-between;
    }
    .fitW{
        width: fit-content;
    }
    .ps-re{
        position: relative;

    }
    .usebutton{
        position: absolute;
        right: 0;
        top: 0;
        z-index: 99;
    }
    /deep/ {
        .el-tree-node__label {
            width: 100%;
            overflow: hidden;
            text-overflow: ellipsis;
        }
        .el-tree-node__content{
            width: 100%;
        }
    }
    .menu{
        /*display: flex;*/
        border: 1px solid #8e8e8e;
        right: 0;
        position: absolute;
        background-color: #fff;
        box-shadow:0 2px 8px rgba(0,0,0,0.1);
    }
    .info{
        /*border: 1px solid #8e8e8e;*/
        padding: 5px 15px;
        font-size: 14px;
    }
    .info:hover{
        background-color: #CCCCCC;

    }
    .el-tree span{
        display: inline-block;
        width: 100%;
    }
    .jian{
        background-color: #409EFF ;
    }
    .zhi{
        background-color: #ff0500;
    }
    .ziicon{
        display: inline-block;
        /*padding:3px 4px;*/
        border-radius: 4px;
        border: 1px;
        color: white;
        width: 20px !important;
        height: 19px;
        line-height: 19px;
        font-size: 12px;
        margin:0 4px;
        text-align: center;
    }
    .p14-9{
        padding: 14px 9px;
    }
</style>